import * as React from "react";
import { RenderChildNodes } from "source/app/presentation/MainPanel/Workflows/RenderChildNodes/RenderChildNodes";
import { RootNodeName } from "source/app/presentation/MainPanel/Workflows/RootNodeName/RootNodeName";
import * as styles from "source/app/presentation/MainPanel/Workflows/Workflows.css";
import { BreadCrumbs } from "source/app/presentation/Workflows/Shared/BreadCrumbs/BreadCrumbs";
import { SetRootNodeAsync } from "source/app/services/Workflows/SetRootNode";
import { IWorkflowsState } from "../IWorkflowsState";
import { WorkflowsLoadingIndicator } from "./WorkflowsLoadingIndicator";

export function RenderAllNodes({ state }: { state: IWorkflowsState }) {
    return (
        <div id="calcTarget_workflows" className={styles.container}>
            <BreadCrumbs rootNode={state.rootNode} />
            <RootNodeName
                rootNode={state.rootNode}
                selectedNodeCount={state.selectedNodeIds.length}
                isMultiSelectMode={state.isMultiSelectMode}
            />
            <WorkflowsLoadingIndicator />
            <RenderChildNodes
                setRootNodeId={(rootNodeId: number) =>
                    SetRootNodeAsync(rootNodeId)
                }
                visibleNodes={state.visibleNodes}
                rootNode={state.rootNode}
                level={0}
                quizMode={state.quizMode}
                sortMode={state.sortMode}
                sortSource={state.sortSource}
                randomNode={state.randomNode}
                scrambledNode={state.scrambledNode}
                index={0}
                isMultiSelectMode={state.isMultiSelectMode}
                selectedNodeIds={state.selectedNodeIds}
            />
        </div>
    );
}
